<main>
    <p-selectButton
    class="custom-select-button"
    [options]="[
    { label: 'Consulta', value: 'consulta' },
    { label: 'Bloqueio', value: 'bloqueio' },
    { label: 'Exceção', value: 'excecao' }
    ]"
    (onOptionClick)="onOptionClick($event)"
    optionLabel="label"
    optionValue="value"
    [allowEmpty]="false"
    [(ngModel)]="selected"
    ></p-selectButton>

    <span pRipple class="close-icon" (click)="closeModal()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20 20L4 4M20 4L4 20" stroke="#585050" stroke-width="2" stroke-linecap="round"/>
        </svg>
    </span>
    <split-agenda-consulta *ngIf="selected =='consulta' "></split-agenda-consulta>
    <split-agenda-bloqueio *ngIf="selected =='bloqueio' "></split-agenda-bloqueio>
    <split-agenda-excecao *ngIf="selected =='excecao' "></split-agenda-excecao>
</main>